export default "__VITE_PUBLIC_ASSET__f88e9d21__"